import { OrderingBizHour } from 'kiolyn-api';
import { parseInt } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment-timezone';

type UnionOverrideKeys<T, U> = Omit<T, keyof U> & U;

export type OrderingBizHourConverted = UnionOverrideKeys<
  OrderingBizHour,
  {
    from_1?: moment.Moment;
    to_1?: moment.Moment;
    from_2?: moment.Moment;
    to_2?: moment.Moment;
  }
>;

export default function inBizHours(
  bizHours: OrderingBizHour[],
  date?: Date,
  timezone?: string
): [boolean, OrderingBizHourConverted?] {
  // If the validated biz hours is empty, then the date is always valid
  if (isEmpty(bizHours) || !timezone) {
    return [true];
  }
  let mDate = moment(date).tz(timezone);
  const bizHoursConverted = bizHours.map(e => {
    const convertTimeBiz = (time?: string) => {
      if (!time) return undefined;
      let storeTime = mDate.clone();
      if (typeof e.day_of_week === 'number') {
        storeTime.weekday(e.day_of_week);
      }
      if (time) {
        const arr = time.split(':').map(parseInt);
        storeTime.set({ hours: arr[0], minutes: arr[1] }).startOf('minute');
      }

      return storeTime;
    };

    return {
      ...e,
      from_1: convertTimeBiz(e.from_1),
      from_2: convertTimeBiz(e.from_2),
      to_1: convertTimeBiz(e.to_1),
      to_2: convertTimeBiz(e.to_2)
    };
  });
  const bizHour = bizHoursConverted.find(
    h => h?.day_of_week === mDate.weekday()
  );
  if (!bizHour || !bizHour.is_working) {
    return [false];
  }
  return [
    mDate.isBetween(bizHour.from_1, bizHour.to_1, undefined, '[)') ||
      mDate.isBetween(bizHour.from_2, bizHour.to_2, undefined, '[)'),
    bizHour
  ];
}
